import { render, staticRenderFns } from "./TeamMemberDialog.vue?vue&type=template&id=01a680c8&scoped=true&"
import script from "./TeamMemberDialog.vue?vue&type=script&lang=js&"
export * from "./TeamMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a680c8",
  null
  
)

export default component.exports